import Context from "../../context";
import closeapp from "../../action/close_app";

export default function Closed(props) {
  return (
    <div
      className={
        props.theme === "dark" ? "flex bg-black text-white" : "flex border-b"
      }
    >
      <div className="flex justify-start w-1/2">
        <div className="p-1 pl-6">
          <p>{props.name}</p>
        </div>
      </div>
      <div className="flex justify-end w-1/2 space-x-1">
        <div className="p-1 cursor-pointer hover:bg-gray-200 hover:text-black w-10 text-center">
          <i className="far fa-window-minimize" />
        </div>
        <div className="p-1 cursor-pointer hover:bg-gray-200 hover:text-black w-10 text-center">
          <i className="far fa-clone" />
        </div>
        <Context.Consumer>
          {(data) => {
            return (
              <div
                onClick={(e) => closeapp(data, props.name)}
                className="p-1 cursor-pointer hover:bg-red-600 hover:text-white w-10 text-center"
              >
                <i className="fas fa-times" />
              </div>
            );
          }}
        </Context.Consumer>
      </div>
    </div>
  );
}
